export const getStores = (state) => state.store

export const getStore = (state) =>  (id) => state.store.find(item => item.id === id)

export const getCurrentStore = (state) => state.currentStore

export const getWarehouses = (state) => state.warehouses

